import { autoserialize, autoserializeAs } from 'cerialize';
import { Vehicle } from './vehicle';

export class TransitProgramVehicle {
  @autoserialize
  transitProgramId: number;

  @autoserializeAs(Vehicle)
  vehicle: Vehicle;

  @autoserialize
  active: boolean;
}
